import BaseAction from './BaseAction.js';
import {loadCompleteTrackJson} from 'engine/json/loadTrackJson.js';

export default class AuditionPreset extends BaseAction {
    constructor(sequencerEngine) {
        super(sequencerEngine);
    }

    async execute({
        track,
        preset,
        loadMods,
        loadEffects
    }) {
        // first get the current preset into a json
        let json = this.sequencerEngine.getTrackPreset(
            track.trackNumber);

        let presetName = track.preset ? track.preset.name : undefined;
        let savedPreset = track.preset;

        // load the preset
        await this.sequencerEngine.auditionPreset(
            preset,
            track.trackNumber,
            loadMods,
            loadEffects);

        return {
            presetJson: json,
            presetName,
            savedPreset
        };
    }

    async undo({payload}) {
        let {track, presetJson, presetName, savedPreset} = payload;
        await this.sequencerEngine.auditionPreset(
            {
                data: presetJson,
                presetName
            },
            track.trackNumber,
            true,
            true,
            false);
        track.presetName = presetName;
        if (savedPreset) {
            track.preset = savedPreset;
            track.preset.name = presetName;
        }
    }
}
 
